"use strict";

angular.module("vendor")
.service("PartnershipTagService", function($resource, appConfig) {

    this.query = function(filter) {
        var params = filter ? filter : {};
        return $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/tags/", {
            catalog: "@catalog",
            exclude_catalog: "@exclude_catalog",
            catalog_group_link: "@catalog_group_link",
            exclude_catalog_group_link: "@exclude_catalog_group_link",
            user_vendor: "@user_vendor",
            exclude_user_vendor: "@exclude_user_vendor"
        }, {
            query: {method: 'GET', isArray: true, ignoreLoadingBar: true}
        }).query(params);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/partnership-tag-filter/partnership-tag.service.js
// module id = 820
// module chunks = 0